import { call, put, takeLatest, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  fetchOrdersRequest,
  fetchOrdersSuccess,
  fetchOrdersFailure,
  createOrderRequest,
  createOrderSuccess,
  createOrderFailure,
  updateOrderStatusRequest,
  updateOrderStatusSuccess,
  updateOrderStatusFailure,
} from '../slices/orderSlice';
import { showLoading, hideLoading } from '../slices/loadingSlice'; // ✅ ADD THIS

const getRole = (state) => state.auth.user?.role;
const getToken = (state) => state.auth.token;
const API_BASE_URL =  process.env.REACT_APP_API_BASE_URL;
function* fetchOrdersSaga() {
  try {
    yield put(showLoading('Loading orders...')); // ✅ ADD THIS
    
    const role = yield select(getRole);
    const token = yield select(getToken);
    
    const endpoint = role === 'ADMIN'
      ? '/api/admin/orders'
      : '/api/customer/orders';
    
    const response = yield call(axios.get, `${API_BASE_URL}${endpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    yield put(fetchOrdersSuccess(response.data));
  } catch (error) {
    console.error('Fetch orders error:', error.response || error);
    yield put(fetchOrdersFailure(error.response?.data?.message || 'Failed to fetch orders'));
  } finally {
    yield put(hideLoading()); // ✅ ADD THIS
  }
}

function* createOrderSaga(action) {
  try {
    yield put(showLoading('Processing your order...')); // ✅ ADD THIS
    
    const token = yield select(getToken);
    
    const response = yield call(
      axios.post,
      `${API_BASE_URL}/api/customer/orders`,
      action.payload,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    yield put(createOrderSuccess(response.data));
  } catch (error) {
    console.error('Create order error:', error.response || error);
    yield put(createOrderFailure(error.response?.data?.message || 'Failed to create order'));
  } finally {
    yield put(hideLoading()); // ✅ ADD THIS
  }
}

function* updateOrderStatusSaga(action) {
  try {
    yield put(showLoading('Updating order status...')); // ✅ ADD THIS
    
    const token = yield select(getToken);
    const { id, status } = action.payload;
    
    const response = yield call(
      axios.put,
      `${API_BASE_URL}/api/admin/orders/${id}/status?status=${status}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    yield put(updateOrderStatusSuccess({ id, status }));
  } catch (error) {
    console.error('Update order status error:', error.response || error);
    yield put(updateOrderStatusFailure(error.response?.data?.message || 'Failed to update order'));
  } finally {
    yield put(hideLoading()); // ✅ ADD THIS
  }
}

export default function* orderSaga() {
  yield takeLatest(fetchOrdersRequest.type, fetchOrdersSaga);
  yield takeLatest(createOrderRequest.type, createOrderSaga);
  yield takeLatest(updateOrderStatusRequest.type, updateOrderStatusSaga);
}